import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";

enum DapConsultServiceEnum {
  getResearcgesByRangeDate = "/get-researches-by-range-date"
}

export default class DapConsultService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/dap-consult");
  }
  public getResearcgesByRangeDate = async (startDate, endDate, searchType): Promise<any[]> =>
    await this.POST(DapConsultServiceEnum.getResearcgesByRangeDate, { startDate, endDate, searchType });
}
